import React, { useMemo } from 'react';
import { Box } from '@mui/material';

const DecorativeCubes = ({ minCubes = 6, maxCubes = 10 }) => {
  const cubes = useMemo(() => {
    const count = Math.floor(Math.random() * (maxCubes - minCubes + 1)) + minCubes;
    return Array.from({ length: count }, (_, index) => ({
      id: index,
      top: `${Math.random() * 90}%`,
      left: `${Math.random() * 95}%`,
      size: Math.floor(Math.random() * 36) + 35,
      rotate: Math.floor(Math.random() * 76) - 30,
      opacity: (Math.random() * 0.2 + 0.4).toFixed(2),
    }));
  }, [minCubes, maxCubes]);

  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      {cubes.map((cube) => (
        <Box
          key={cube.id}
          component="img"
          src="/img/cube.png"
          alt=""
          sx={{
            position: 'absolute',
            top: cube.top,
            left: cube.left,
            width: cube.size,
            height: cube.size,
            opacity: cube.opacity,
            transform: `rotate(${cube.rotate}deg)`,
          }}
        />
      ))}
    </Box>
  );
};

export default DecorativeCubes;
